import { StyleSheet, Platform } from 'react-native';

const HEADER_MAX_HEIGHT = 250;
const HEADER_MIN_HEIGHT = Platform.OS === 'ios' ? 60 : 73;

const styles: any = StyleSheet.create({
	container: {
		backgroundColor: '#FBFAFA'
	},
	row: {
		flex: 1,
		alignItems: 'center'
	},
	text: {
		fontSize: 20,
		marginBottom: 15,
		alignItems: 'center'
	},
	mt: {
		marginTop: 18
	},
	fill: {
		flex: 1
	},
	content: {
		flex: 1
	},
	header: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		backgroundColor: '#438eb9',
		overflow: 'hidden',
		height: HEADER_MAX_HEIGHT
	},
	backgroundImage: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		width: null,
		height: HEADER_MAX_HEIGHT,
		resizeMode: 'cover'
	},
	bar: {
		backgroundColor: 'transparent',
		flexDirection: 'row',
		marginTop: Platform.OS === 'ios' ? 28 : 38,
		height: 32,
		alignItems: 'center',
		justifyContent: 'center',
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0
	},
	title: {
		color: 'white',
		fontSize: 18
	},
	centreDetails: {
		alignItems: 'center',
		top: HEADER_MIN_HEIGHT + 40,
		flex: 1
	},
	customerName: {
		color: 'white',
		backgroundColor: 'transparent',
		fontSize: 24
	},
	customerNumber: {
		color: 'white',
		backgroundColor: 'transparent',
		fontSize: 16
	},
	contactButtonsContainer: {
		backgroundColor: 'transparent',
		flexDirection: 'row',
		alignContent: 'space-between',
		padding: 20,
		paddingHorizontal: 50,
		width: 450
		//alignItems: 'flex-start',
		//alignContent: 'center',
		//flex: 1
		//justifyContent: 'center'
	},
	contactButton: {
		flex: 1,
		marginHorizontal: 10,
		alignItems: 'center'
	},
	scrollViewContent: {
		top: HEADER_MAX_HEIGHT
	},
	row: {
		height: 40,
		margin: 16,
		backgroundColor: '#D3D3D3',
		alignItems: 'center',
		justifyContent: 'center'
	},
	detailsTabRow: {
		flexDirection: 'row',
		marginBottom: 10
	},
	detailsTabIcon: {
		fontSize: 24,
		width: 30,
		alignSelf: 'center'
	},
	detailsTabLabel: {
		flex: 1,
		fontSize: 16,
		color: 'grey',
		alignSelf: 'center'
	},
	detailsTabData: {
		flex: 2.5,
		alignSelf: 'center'
	}
});

export default styles;
